import { createBrowserDeviceId } from './browser-env'

const DEVICE_KEY = 'iphon_local_device_id'
const CARD_SESSION_KEY = 'iphon_local_card_session'
const CARD_SESSION_TTL = 60 * 60 * 1000
const DEVICE_COOKIE_MAX_AGE = 365 * 24 * 60 * 60

function getDeviceIdFromCookie() {
  const prefix = `${DEVICE_KEY}=`
  const item = document.cookie.split('; ').find(value => value.startsWith(prefix))
  return item ? decodeURIComponent(item.slice(prefix.length)) : ''
}

function saveDeviceId(deviceId) {
  localStorage.setItem(DEVICE_KEY, deviceId)
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${DEVICE_KEY}=${encodeURIComponent(deviceId)}; Path=/; Max-Age=${DEVICE_COOKIE_MAX_AGE}; SameSite=Lax${secure}`
}

export function getOrCreateDeviceId() {
  const cookieDeviceId = getDeviceIdFromCookie()
  if (cookieDeviceId) {
    localStorage.setItem(DEVICE_KEY, cookieDeviceId)
    return cookieDeviceId
  }

  const cached = localStorage.getItem(DEVICE_KEY)
  if (cached) {
    saveDeviceId(cached)
    return cached
  }

  const deviceId = createBrowserDeviceId()
  saveDeviceId(deviceId)
  return deviceId
}

export function saveCardSession(cardKey, deviceId, cardInfo = {}) {
  const payload = {
    cardKey,
    deviceId,
    cardInfo,
    expiresAt: Date.now() + CARD_SESSION_TTL,
  }
  localStorage.setItem(CARD_SESSION_KEY, JSON.stringify(payload))
  return payload
}

export function getCardSession() {
  const raw = localStorage.getItem(CARD_SESSION_KEY)
  if (!raw) {
    return null
  }
  try {
    const session = JSON.parse(raw)
    if (!session.cardKey || !session.deviceId || !session.expiresAt) {
      clearCardSession()
      return null
    }
    if (Date.now() >= session.expiresAt) {
      clearCardSession()
      return null
    }
    return session
  } catch (error) {
    clearCardSession()
    return null
  }
}

export function clearCardSession() {
  localStorage.removeItem(CARD_SESSION_KEY)
}

export function getRemainingMinutes(expiresAt) {
  return Math.max(0, Math.ceil((expiresAt - Date.now()) / 60000))
}
